export const photos = [
    {
        src: "/images/1595331681056.jpg",
        width: 3,
        height: 4.5
    },
    {
        src: "/images/1597282036095.jpg",
        width: 1.5,
        height: 1
    },
    {
        src: "/images/1597281943958.jpg",
        width: 3,
        height: 4.5
    },
    {
        src: "/images/1597281998980.jpg",
        width: 3,
        height: 4.5
    },
    {
        src: "/images/IMG_0395.jpg",
        width: 1.5,
        height: 1
    },
    {
        src: "/images/1597282146319.jpg",
        width: 3,
        height: 4.5
    },
    {
        src: "/images/1597281800020.jpg",
        width: 3,
        height: 4.5
    },
    {
        src: "/images/1597281831967.jpg",
        width: 1.5,
        height: 1
    },
    {
        src: "/images/1597281961321.jpg",
        width: 3,
        height: 4.5
    },
    {
        src: "/images/1597281915928.jpg",
        width: 3,
        height: 4.5
    },
];
